export const SUPPLIER_ADDED = 'supplierAdded';
export const SUPPLIER_REMOVED = 'supplierRemoved';
export const CANCELLED = 'cancelled';